import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { BodyRouteParamsRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type EditChatroomRequest = paths['/chatrooms/{id}']['patch']['requestBody']['content']['application/json'];
type EditChatroomRouteParameters = paths['/chatrooms/{id}']['patch']['parameters']['path'];

export const editChatroom = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<EditChatroomRequest, EditChatroomRouteParameters>) =>
  getNodeApiAxiosInstance().patch<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(
    routes.chatrooms.edit(id),
    body,
  );
